const { BaseClient, setupClient } = require('./base-client')

const { agreementUrl } = require('sci/utils')

class Client extends BaseClient {
    url (path) {
        return agreementUrl(path)
    }
}

module.exports = setupClient(Client)



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/agreement-client.js